import { render, staticRenderFns } from "./cModalViewActivesDetail.vue?vue&type=template&id=288464fe&scoped=true&lang=es"
import script from "./cModalViewActivesDetail.vue?vue&type=script&lang=js"
export * from "./cModalViewActivesDetail.vue?vue&type=script&lang=js"
import style0 from "./cModalViewActivesDetail.vue?vue&type=style&index=0&id=288464fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288464fe",
  null
  
)

export default component.exports